import React, { useEffect, useState } from "react";
import ClientCareLetter from "../../ClientCareLetter";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getClientLetter } from "../../../../../thunks/instruction";
import { Box } from "@mui/material";
import moment from "moment";
import ClientCareSection from "../../ClientCareSection";
import TermsClause from "../../TermsClause";
import {
  CLIENT_CARE_LETTER_SECTIONS,
  FEES_CLAUSES,
  OTHER_CHARGES,
  TERMS_SECTIONS,
} from "../../../../../utils/clientCareLetterData";

const ClientCarePage = ({ show }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const instructionId = params.id;
  const instructionData = useSelector(
    (state) => state.instruction.instructionDashboardData
  );
  const [isLoader, setLoader] = useState(false);

  const [data, setData] = useState(null);

  const getClientCareDataById = async () => {
    try {
      setLoader(true);
      const response = await dispatch(getClientLetter(instructionId)).unwrap();
      if (response?.data) {
        let responseData = response?.data;
        setData({
          ...responseData,
          consultantName: responseData?.ownerOfInstructionByName,
          parties: responseData?.InstructionClients,
          clientCare: responseData?.InstructionClientCare?.clientCare,
        });
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => {
    getClientCareDataById();
  }, []);

  return (
    <Box sx={{ padding: 4 }}>
      {/* header  */}
      <div className="">
        <div className="header_top">
          <div className="form_name_div">
            <span className="text-style text-bold">Client Care Letter</span>
          </div>
        </div>
      </div>
      {/* Body */}
      <div className="flex-row-wrap-center center_container">
        <div className="">
          {/* Client Information */}
          <div className="flex-column gap-30 mb-50">
            <div>
              <div className="applicationTypeHeading">Consultant</div>
              <div className="text-big">{`${
                data?.ownerOfInstruction?.firstName || "NA"
              } ${data?.ownerOfInstruction?.lastName || "NA"}`}</div>
            </div>

            <div>
              <div className="applicationTypeHeading">Client(s) Name</div>
              <div className="text-big">
                {data?.parties?.[0]?.firstName +
                  " " +
                  data?.parties?.[0]?.lastName}
                {data?.applicationType === "Joint" &&
                  ` & ${
                    data?.parties?.[1]?.firstName +
                    " " +
                    data?.parties?.[1]?.lastName
                  }`}
              </div>
            </div>

            <div>
              <div className="applicationTypeHeading">Address</div>
              <div className="text-big">
                {data?.parties?.[0]?.InstructionFactFind?.clientDetails?.address
                  ?.street1 ?? ""}
                ,
                {data?.parties?.[0]?.InstructionFactFind?.clientDetails?.address
                  ?.street2 ?? ""}
                ,
                {data?.parties?.[0]?.InstructionFactFind?.clientDetails?.address
                  ?.city ?? ""}
                ,
                {data?.parties?.[0]?.InstructionFactFind?.clientDetails?.address
                  ?.state ?? ""}
                ,
                {data?.parties?.[0]?.InstructionFactFind?.clientDetails?.address
                  ?.zip ?? ""}
                ,
                {data?.parties?.[0]?.InstructionFactFind?.clientDetails?.address
                  ?.country ?? ""}
              </div>
            </div>
          </div>

          {/* Introduction */}
          <div className="flex-column gap-20 mb-50">
            {CLIENT_CARE_LETTER_SECTIONS.slice(0, 4).map((section) => (
              <ClientCareSection key={section.key} section={section} />
            ))}
          </div>

          {/* BREAK */}
          <div className="section flex-column gap-20 mb-50">
            {CLIENT_CARE_LETTER_SECTIONS.slice(4).map((section) => (
              <ClientCareSection key={section.key} section={section} />
            ))}
          </div>

          {/* BREAK */}
          <div className="section mb-40">
            <div className="text-style text-bold text-center mb-40">
              Your Legacy and Estate Planning Instructions
            </div>

            <div className="mb-30">
              <div className="key mb-20 text-big">
                The documents and services you are instructing your Consultant
                to arrange are:
              </div>
              <div className="flex-column gap-10">
                <div className="flex-row">
                  <div className="width-70 key">Particulars</div>
                  <div className="width-15 key text-center">Instructed</div>
                  <div className="width-15 key text-center">Quantity</div>
                </div>
                {data?.clientCare?.documentsToBeArranged?.map(function (
                  item,
                  index
                ) {
                  return (
                    <div className="flex-row" key={index}>
                      <div className="width-70">{item.particular ?? ""}</div>
                      <div className="width-15 text-center text-green">
                        {item?.isInstructed ? "✔" : "-"}
                      </div>
                      <div className="width-15 text-center">
                        {item.quantity ?? "0"}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* How much will my Estate Planning cost? */}
            <div className="mb-30">
              <div className="text-green text-big mb-20">
                How much will my Estate Planning cost?
              </div>
              <div className="flex-column gap-10">
                <div className="flex-row-sb">
                  <div className="applicationTypeHeading">Particulars</div>
                  <div className="applicationTypeHeading">Cost</div>
                </div>
                <div className="flex-row-sb">
                  <div className="">
                    Fixed fee for your estate planning (before VAT)
                  </div>
                  <div className="">
                    &#163;{" "}
                    {Number(
                      data?.clientCare?.estatePlanningCost?.fixedLegacyCost
                    )?.toFixed(2) || "NA"}
                  </div>
                </div>
                <div className="flex-row-sb">
                  <div className="">Discount</div>
                  <div className="">
                    &#163;{" "}
                    {Number(
                      data?.clientCare?.estatePlanningCost?.discount?.cost
                    )?.toFixed(2) || "NA"}
                  </div>
                </div>
                <div className="flex-row-sb">
                  <div className="">VAT at 20%</div>
                  <div className="">
                    &#163;{" "}
                    {Number(data?.clientCare?.estatePlanningCost?.vat)?.toFixed(
                      2
                    ) || "NA"}
                  </div>
                </div>
                <div className="flex-row-sb">
                  <div className="">Total fee, including VAT</div>
                  <div className="">
                    &#163;{" "}
                    {Number(
                      data?.clientCare?.estatePlanningCost?.total
                    )?.toFixed(2) || "NA"}
                  </div>
                </div>
                <div className="flex-row-sb">
                  <div className="">
                    Total to pay, including the third-party fees below
                  </div>
                  <div className="">
                    &#163;{" "}
                    {Number(
                      data?.clientCare?.estatePlanningCost
                        ?.totalIncludingDisbursements
                    )?.toFixed(2) || "NA"}
                  </div>
                </div>
              </div>
              <div className="text-big mt-20">
                If you appoint Squiggle Consult Ltd as your professional
                executor, there is nothing to pay now. When the time comes, we
                will appoint Squiggle Probate Ltd to carry out the work, and its
                fees are paid from your estate. Sections 1.4 to 1.6 of the Terms
                of Engagement explain how those fees are worked out. You do not
                need a professional executor for your Will to be valid, and
                changing your mind later means changing your Will.
              </div>
            </div>

            {/* Payment information & Breakdown */}
            <div>
              <div className="text-green text-big mb-20">
                Payment information & Breakdown
              </div>
              <div className="flex-column gap-10 mb-20">
                <div className="text-big">
                  Please make your payment to Squiggle Consult Ltd. Your fee
                  covers preparing your documents and the work of any law firm
                  we use, so there is nothing further to pay for the services
                  listed above.
                </div>
                <div className="text-big">
                  Fees charged by HM Land Registry and the Office of the Public
                  Guardian are shown below. We pass these on at cost.
                </div>
                <div className="text-big">
                  You can pay by bank transfer, debit or credit card, Klarna,
                  PayPal or cheque. For bank transfers: HSBC, Squiggle Consult,
                  sort code 40-08-32, account number 82218070.
                </div>
                <div className="text-big">
                  We will never tell you by email that our bank details have
                  changed. If you get a message saying they have, please call us
                  on 01233 659796 before you pay.
                </div>
              </div>
              <div className="flex-column gap-10">
                <div className="flex-row-sb">
                  <div className="">Payment to Squiggle Consult LTD.</div>
                  <div className="">
                    &#163;{" "}
                    {Number(
                      data?.clientCare?.paymentBreakdownInformation
                        ?.toSquiggleConsult
                    )?.toFixed(2) || "NA"}
                  </div>
                </div>
                <div className="flex-row-sb">
                  <div className="">Payment to Land Registry</div>
                  <div className="">
                    &#163;{" "}
                    {
                      data?.clientCare?.paymentBreakdownInformation
                        ?.toLandRegistry
                    }
                  </div>
                </div>
                <div className="flex-row-sb">
                  <div className="">
                    Payment to the Office of Public Guardian
                  </div>
                  <div className="">
                    &#163;{" "}
                    {
                      data?.clientCare?.paymentBreakdownInformation
                        ?.toPublicGuardianOffice
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* BREAK */}
          {/* Your Instruction and Declaration */}
          <div className="section">
            <div className="text-style text-bold text-center mb-10">
              Your Instruction and Declaration
            </div>
            <div className="text-big mb-10">
              Please read this letter and the Terms of Engagement before you
              sign. If anything is unclear, or you do not agree with it, talk to
              your Consultant first.
            </div>
            <div className="text-big mb-20">
              By signing, you confirm that you have received both documents,
              that the instructions on the previous page are correct, and that
              you agree to pay the fees shown.
            </div>
            <div className="text-style text-bold text-center mb-10">
              Please check as appropriate
            </div>
            <div className="flex-column gap-20">
              {/* Each declaration */}
              {/* Declaration 1 */}
              <div className="flex-row-only gap-20 vertical-top">
                <div className="text-center">
                  {data?.clientCare?.declarations?.permissionToShareDetails ? (
                    <div className="checked">✔</div>
                  ) : (
                    <div className="notChecked"></div>
                  )}
                </div>
                <div className="">
                  I/We give our Consultant permission to share my/our details
                  along with any and all information collected, with Squiggle
                  for quality control purposes in relation to our Legacy and
                  Estate Planning instructions.
                </div>
              </div>
              {/* Declaration 2 */}
              <div className="flex-row-only gap-20 vertical-top">
                <div className="text-center">
                  {data?.clientCare?.declarations
                    ?.permissionToInstructReleventInformation ? (
                    <div className="checked">✔</div>
                  ) : (
                    <div className="notChecked"></div>
                  )}
                </div>
                <div className="">
                  I/We give Squiggle permission to instruct and to share my/our
                  relevant information with one or more third parties as per the
                  ‘Confidentiality and your information’ section of this
                  document, for the purposes of providing Legacy & Estate
                  Planning documents and services.
                </div>
              </div>
              {/* Declaration 3 */}
              <div className="flex-row-only gap-20 vertical-top">
                <div className="text-center">
                  {data?.clientCare?.declarations
                    ?.acceptingSoleResponsibility ? (
                    <div className="checked">✔</div>
                  ) : (
                    <div className="notChecked"></div>
                  )}
                </div>
                <div className="">
                  it has been explained to me/us that my/our Consultant accepts
                  sole responsibility for the consulting process that resulted
                  in me/us providing these specific instructions and that the
                  professionals who draft the documents or provide the services
                  hold responsibility for the quality of the document(s) /
                  service only.
                </div>
              </div>
              {/* Declaration 4 */}
              <div className="flex-row-only gap-20 vertical-top">
                <div className="text-center">
                  <div className="notChecked"></div>
                </div>
                <div className="">
                  I/We have elected to instruct Squiggle to commence
                  arrangements for the provision of my/our chosen Legacy and
                  Estate Planning documents and/or services immediately. I/We
                  understand that if I/we cancel my/our instructions during or
                  after the 14 day cancellation period I/we may be liable to pay
                  the cost of any works undertaken.
                </div>
              </div>
              {/* Declaration 5 */}
              <div className="flex-row-only gap-20 vertical-top">
                <div className="text-center">
                  {data?.clientCare?.declarations
                    ?.requestToReferingFinancialAdvisor ? (
                    <div className="checked">✔</div>
                  ) : (
                    <div className="notChecked"></div>
                  )}
                </div>
                <div className="">
                  I/We request that either my Consultant or Squiggle refer me to
                  an appropriate Financial Adviser or Protection Adviser and
                  give permission to share with them my/our contact details.
                </div>
              </div>
              {/* Declaration 6 */}
              <div className="flex-row-only gap-20 vertical-top">
                <div className="text-center">
                  {data?.clientCare?.declarations
                    ?.requestToReferingPlanningAdvisor ? (
                    <div className="checked">✔</div>
                  ) : (
                    <div className="notChecked"></div>
                  )}
                </div>
                <div className="">
                  I/We request that either my Consultant or Squiggie refer me to
                  an appropriate Tax Planning Adviser and give permission to
                  share with them my/our contact details.
                </div>
              </div>
              {/* Declaration 7 */}
              <div className="flex-row-only gap-20 vertical-top">
                <div className="text-center">
                  {data?.clientCare?.declarations
                    ?.instructingToNotifyExecutors ? (
                    <div className="checked">✔</div>
                  ) : (
                    <div className="notChecked"></div>
                  )}
                </div>
                <div className="">
                  I/We instruct Squiggle to notify my Executors, Trustees and
                  Attorneys of their responsibilities and the nature of my/our
                  Legacy & Estate Planning but not the specific details.
                </div>
              </div>
            </div>
            {/* Signature */}
            <div className="flex-row-sb my-10">
              <div className="flex-column gap-10 width-45">
                <div className="text-22">
                  {" "}
                  {`${data?.parties?.[0]?.firstName} ${data?.parties?.[0]?.lastName}`}{" "}
                </div>
                <div className="applicationTypeHeading">Signature</div>
                <div className="">
                  <img
                    className="address_document_image"
                    src={data?.clientCare?.signature?.[0]?.img ?? ""}
                    width="200px"
                    height="100px"
                    alt="squiggle"
                  />
                </div>
                <div className="text-right">
                  {moment(data?.clientCare?.signature?.[0]?.date).format(
                    "DD/MM/YYYY"
                  ) ?? ""}
                </div>
              </div>
              {data?.applicationType === "Joint" && (
                <div className="flex-column gap-10 width-45">
                  <div className="text-22">{`${data?.parties?.[1]?.firstName} ${data?.parties?.[1]?.lastName}`}</div>
                  <div className="applicationTypeHeading">Signature</div>
                  <div className="">
                    <img
                      className="address_document_image"
                      src={data?.clientCare?.signature?.[1]?.img ?? ""}
                      width="200px"
                      height="100px"
                      alt="squiggle"
                    />
                  </div>
                  <div className="text-right">
                    {moment(data?.clientCare?.signature?.[1]?.date).format(
                      "DD/MM/YYYY"
                    ) ?? ""}
                  </div>
                </div>
              )}
            </div>
            <div className="flex-column gap-10">
              <div className="text-small">
                This agreement is between you and your Consultant of Squiggle.
              </div>
              <div className="text-small">
                Squiggle Consult LTD. A company registered in England & Wales
                and with the registration number 10816512.
              </div>
              <div className="text-small">
                Suite 2069, Letraset Building, Wotton Road, Ashford, Kent, TN23
                6LN01233 659796 hello@squiggleconsult.co.uk
                www.squiggleconsult.co.uk
              </div>
            </div>
          </div>

          {/* Terms of Engagement */}
          <div className="section">
            <div className="text-style text-bold text-center my-10">
              Terms of Engagement
            </div>
            <div className="flex-column gap-10">
              <div className="text-small">
                These are the terms on which Squiggle Consult Ltd (company number
                10816512) provides services to you. Please read them with your
                Client Care Letter.
              </div>
              <div className="text-small">
                Squiggle is not a firm of solicitors and is not regulated by the
                Solicitors Regulation Authority or the Financial Conduct Authority.
                Where your plan includes work that only a regulated law firm can do,
                that work is carried out by one of the regulated firms named in our
                pre-contract information.
              </div>
              <div className="text-small">
                English law applies to this agreement and the courts of England and
                Wales will deal with any dispute. If you live in Scotland or Northern
                Ireland you can also use your local courts.
              </div>
            </div>

            {/* 1 - Fees */}
            <div>
              <div className="text-big text-green mt-20 mb-10">1. Fees</div>
              <div className="flex-column gap-20">
                <div className="flex-row-only text-top gap-20">
                  <div className="text-small">1.1</div>
                  <div className="flex-column gap-10">
                    <div className="text-small">
                      Your fixed fee, and any fees we pay to others for you, are set
                      out in your Client Care Letter. Our prices include VAT unless we
                      tell you otherwise in writing.
                    </div>
                  </div>
                </div>
                <div className="flex-row-only text-top gap-20">
                  <div className="text-small">1.2</div>
                  <div className="flex-column gap-10">
                    <div className="text-small">
                      Other charges. These only apply in the situations described. We
                      will always tell you the amount and ask you to agree before we do
                      the work. All amounts include VAT.
                    </div>
                    <table className="other_charges_table text-small">
                      <thead>
                        <tr>
                          <th className="width-20">Charge</th>
                          <th className="width-50">When it applies</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {OTHER_CHARGES.map((item) => (
                          <tr key={item.charge}>
                            <td>{item.charge}</td>
                            <td>{item.whenItApplies}</td>
                            <td>{item.amount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {FEES_CLAUSES.map((clause) => (
                  <TermsClause
                    key={clause.number}
                    number={clause.number}
                    paragraphs={[clause.text]}
                  />
                ))}
              </div>
            </div>

            {TERMS_SECTIONS.map((section) => (
              <div key={section.heading}>
                <div className="text-big text-green mt-20 mb-10">
                  {section.heading}
                </div>
                <div className="flex-column gap-20">
                  {section.clauses.map((clause) => (
                    <TermsClause
                      key={clause.number}
                      number={clause.number}
                      paragraphs={clause.paragraphs}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default ClientCarePage;
